import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import Auth from './auth';

Vue.config.productionTip = false;

Vue.use(Auth);

Vue.filter("formatDate", function (value) {
  if (!value) return "";
  value = value.toString();
  var ft = value.indexOf("T");
  if(ft>0){
    value = value.substring(0,ft);
  }
  var exp = value.split("-");
  return exp[2] + "/" + exp[1] + "/" + exp[0];
});

Vue.filter("formatTime", function (value) {
  if (!value) return "00:00:00";
  value = value.toString();
  var ft = value.indexOf("T");
  if(ft>0){
    value = value.substring(ft+1);
  }else{
    value = "00:00:00";
  }
  var exp = value.split(":");
  value = exp[0] + ":" + exp[1] + ":" + exp[2];
  return value.substring(0,8);
});

Vue.filter("formatMoney", function(value) {
  var val = (value / 1).toFixed(2).replace(".", ",");
  return val;
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');